import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class EmptyTenantLeaseSourceTypeError extends CodedError {
  static get errorName() {
    return errorCodeTypes.emptyTenantLeaseSourceTypeError.code;
  }

  constructor(
    message = errorCodeTypes.emptyTenantLeaseSourceTypeError.message
  ) {
    super(message);
    this.code = errorCodeTypes.emptyTenantLeaseSourceTypeError.code;
    this.message = `${message} ${errorCodeTypes.emptyTenantLeaseSourceTypeError.code}`;
    this.name = errorCodeTypes.emptyTenantLeaseSourceTypeError.name;
  }
}
